<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">بيانات الطلب</h5>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "joinrequestForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"> الأسم</label>
                                <input class="form-control" id="validation01" disabled type="text" formControlName="name"
                                [tooltip]="fc.name.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.name.valid && (fc.name.touched)"
                                [class.is-invalid]="fc.name.invalid && (fc.name.touched)"
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                            <!-- mobile  -->
                            <div class="col-6 mb-3">
                                <label for="validation02"> الهاتف</label>
                                <input class="form-control" id="validation02" disabled type="text" formControlName="mobile"
                                [tooltip]="fc.mobile.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.mobile.valid && (fc.mobile.touched)"
                                [class.is-invalid]="fc.mobile.invalid && (fc.mobile.touched)"
                                     required
                                     onlyNumbers
                                     placeholder="الهاتف"
                                    containerClass="" />
                            </div>
                            <!-- address  -->
                            <div class="col-6 mb-3">
                                <label for="validation03"> الموقع</label>
                                <input class="form-control" id="validation03" disabled type="text" formControlName="address"
                                [tooltip]="fc.address.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.address.valid && (fc.address.touched)"
                                [class.is-invalid]="fc.address.invalid && (fc.address.touched)"
                                     required
                                     
                                     placeholder="الموقع"
                                    containerClass="" />
                            </div>
                            
                            <!-- comment  -->
                            <div class="col-6 mb-3">
                                <label for="validation04"> تعليق</label>
                                <input class="form-control" id="validation04" disabled type="text" formControlName="comments"
                                [tooltip]="fc.comments.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.comments.valid && (fc.comments.touched)"
                                [class.is-invalid]="fc.comments.invalid && (fc.comments.touched)"
                                     required
                                     placeholder="تعليق"
                                    containerClass="" />
                            </div>
                            
                             <div class="col-6 mb-3">
                                <label for="validationCustom05"> المدينة </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="cityId" disabled
                                    class="form-control p-0" placeholder="اختر المدينة"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of cities" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                             <div class="col-6 mb-3">
                                <label for="validationCustom06"> نوع الانضمام </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="jointypeId" 
                                    class="form-control p-0" placeholder="اختر نوع الانضمام"
                                    containerClass="" 
                                    id="validationCustom06">
                                    <ng-option *ngFor="let item of jointype" [value]="item.id">{{item.title}}</ng-option>
                                </ng-select>
                            </div>
                         
                        </div>
<!--                         
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div> -->
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

